"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var RegexTransform = /** @class */ (function (_super) {
    __extends(RegexTransform, _super);
    function RegexTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegexTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = queryResponse;
        if (queryResponse) {
            var regexTransformOptions = this.options.regexTransformOptions;
            if (regexTransformOptions) {
                var pattern = regexTransformOptions.pattern, flags = regexTransformOptions.flags, index = regexTransformOptions.index;
                try {
                    var regex = new RegExp(pattern, flags);
                    var result = regex.exec(response);
                    if (typeof index === 'number' && result.length > index) {
                        response = result[index];
                    }
                    else {
                        response = result;
                    }
                }
                catch (ex) {
                    console.error("RegexTransform: ", ex.message);
                }
            }
        }
        return response;
    };
    return RegexTransform;
}(BaseTransform_1.BaseTransform));
exports.RegexTransform = RegexTransform;
//# sourceMappingURL=RegexTransform.js.map